import { authClient } from './auth-client';
import { createTokenCache } from './token-cache';

// One cache, not one per caller: the console bearer (admin/api.ts) and the cockpit WS
// token (lib/ws-url.ts) are the SAME JWT, so a 401 in one must drop the other's copy.
// TTL sits well inside the BFF's 15m signing lifetime.
const TOKEN_TTL_MS = 5 * 60_000;

export const authTokenCache = createTokenCache(
  async () => (await authClient.token().catch(() => null))?.data?.token ?? null,
  TOKEN_TTL_MS,
);
